module.exports = __webpack_public_path__ + "src/img/sketchrunner/feature-small.ffd38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sketchrunner/feature-small.jpg
// module id = 109
// module chunks = 0